export interface Module {
  num: string
  title: string
  description: string
}

export const modules: Module[] = [
  {
    num: '1',
    title: 'Professional Assessment & Goal Planning™',
    description:
      'Professional evaluation templates, assessment forms, patient profiles, treatment planning tools, SMART goal frameworks, objective templates, baseline documentation, and clinical planning resources ready to use from the very first session.',
  },
  {
    num: '2',
    title: 'Ready-to-Use Therapy Activities™',
    description:
      'Professionally organized therapy activities covering articulation, phonology, expressive language, receptive language, fluency, voice, social communication, cognitive communication, and functional communication with clear objectives, progressions, and adaptations.',
  },
  {
    num: '3',
    title: 'Therapy Session Builder™',
    description:
      'Complete 30, 45, and 60-minute therapy sessions including warm-ups, structured intervention activities, reinforcement tasks, home practice suggestions, and professional session templates ready to deliver.',
  },
  {
    num: '4',
    title: 'Printable Therapy Resources™',
    description:
      'Printable worksheets, flashcards, cue cards, visual supports, communication boards, home practice sheets, therapy games, and ready-to-use clinical resources designed to save preparation time.',
  },
  {
    num: '5',
    title: 'Progress Tracking & Documentation™',
    description:
      'Professional progress notes, SOAP templates, treatment reports, goal trackers, parent communication forms, school reports, outcome monitoring tools, and documentation systems organized for daily clinical use.',
  },
  {
    num: '6',
    title: 'Professional Clinical Toolkit™',
    description:
      'Caseload management tools, therapy planners, scheduling templates, workflow systems, productivity resources, organization templates, printable planners, and professional clinical tools designed to optimize every aspect of your practice.',
  },
]

export interface Bonus {
  label: string
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    label: 'BONUS 1',
    title: 'Pediatric Therapy Activities Vault™',
    description:
      'A professional collection of high-quality pediatric speech therapy activities covering articulation, phonology, expressive language, receptive language, vocabulary development, auditory processing, and social communication. Every activity is fully structured, immediately usable, and designed for real clinical practice.',
  },
  {
    label: 'BONUS 2',
    title: 'Home Practice Toolkit™',
    description:
      'Ready-to-use home practice programs that help families reinforce therapy between sessions. Includes printable exercises, caregiver instructions, practice schedules, progress sheets, and engaging activities designed to improve carryover outside the therapy room.',
  },
  {
    label: 'BONUS 3',
    title: 'Clinical Goal Bank™',
    description:
      'An extensive library of professionally written therapy goals organized by communication area, age group, and difficulty level. Includes measurable objectives, short-term and long-term goals, progression recommendations, and treatment planning references ready to adapt to each patient.',
  },
  {
    label: 'BONUS 4',
    title: 'Therapy Games Collection™',
    description:
      'A complete collection of therapeutic games designed to increase patient engagement while targeting articulation, language, fluency, vocabulary, comprehension, auditory memory, and communication skills through meaningful clinical activities.',
  },
  {
    label: 'BONUS 5',
    title: 'Professional Caseload Management System™',
    description:
      'Professional organization tools including planners, scheduling templates, patient trackers, documentation checklists, treatment calendars, productivity systems, and workflow resources designed to simplify everyday clinical management.',
  },
]

export interface Benefit {
  title: string
  description: string
}

export const benefits: Benefit[] = [
  {
    title: '⚡ Save Hours Every Week',
    description:
      'Stop creating therapy sessions, treatment activities, printable materials, therapy goals, progress notes, and documentation from scratch. Simply open the system, choose the appropriate resources, and begin every session fully prepared.',
  },
  {
    title: '👑 Deliver Therapy With Greater Confidence',
    description:
      'Work with structured therapy plans, organized activities, professional documentation tools, printable resources, and complete clinical systems that eliminate uncertainty from your daily practice.',
  },
  {
    title: '🗣️ Help Your Patients Make Better Progress',
    description:
      'Support improvements in speech, language, communication, fluency, voice, and functional communication using structured intervention resources developed for professional clinical practice.',
  },
  {
    title: '😊 Provide A More Professional Therapy Experience',
    description:
      'Use complete treatment plans, organized documentation, printable resources, clinical templates, and ready-to-use materials to deliver a higher-quality experience for every patient.',
  },
]
